/* eslint-disable angular/controller-name */

angular.
module("digiexam").
controller("OverviewController", function OverviewController(
	dxDialog,
	dxSession,
	RoleTypeEnum
) {
	"use strict";

	var self = this;

	function showGettingStartedGuidePopup() {
		dxDialog.show({
			templateUrl: "/partials/popups/getting-started-guide.html",
		});
	}

	self.user = dxSession.getUser();
	self.dxSession = dxSession;
	self.userIsTeacher = dxSession.getRole().roleType === RoleTypeEnum.TEACHER;

	self.user.load().then(function success() {
		if (self.userIsTeacher && self.user.gettingStartedGuideDisabled === false) {
			showGettingStartedGuidePopup();
		}
	});
});
